import axios from 'axios';

export const apiLogin = axios.create({
  baseURL: 'https://mv0csoqlbk.execute-api.us-east-2.amazonaws.com/dev/authenticate/',
});
//API LOGIN GAZIN = https://hdmdm5n7s9.execute-api.us-east-2.amazonaws.com/prod/authenticate/
//API LOGIN JP = https://mv0csoqlbk.execute-api.us-east-2.amazonaws.com/dev/authenticate/
export const apiModulo = axios.create({
  baseURL: 'https://xin2kdxlub.execute-api.us-east-2.amazonaws.com/prod/',
});

export const apiWS = axios.create({
  baseURL: 'https://trly04t1f8.execute-api.us-west-2.amazonaws.com/dev/api/v1',
  headers: {
    'Content-Type': 'application/json',
  },
});

export const apiDiscador = axios.create({
  baseURL: 'https://3c.fluxoti.com/api/v1/',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});

export const apiWhatsApp = axios.create({
  baseURL: 'https://api-transbordo.dsb.gl/api',
});

export const apiOperador = axios.create({
  // baseURL: 'http://localhost:3000/dev/operador-cadastro',
  baseURL: 'https://9lko66kgqi.execute-api.us-east-2.amazonaws.com/dev/operador-cadastro',
});

export const apiCobranca = axios.create({
  baseURL: 'https://api-acionaone.dsb.gl/v1',
});
